import { isPrivateBeta } from './lib/betaStorage'
import { BetaExperience } from './beta/BetaExperience'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App'
import { AppProvider } from './store/AppContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { JnrLillianPrototype } from './pages/JnrLillianPrototype'
import './lib/jnrHomeVideoTest'
import './index.css'
import './nixi-feelings.css'

const isJnrPreview = !isPrivateBeta && window.location.hash.replace(/^#/, '').split('?')[0] === '/jnr-preview'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      {isJnrPreview ? (
        <JnrLillianPrototype />
      ) : (
        <HashRouter>
          <AppProvider>
            {isPrivateBeta ? <BetaExperience><App /></BetaExperience> : <App />}
          </AppProvider>
        </HashRouter>
      )}
    </ErrorBoundary>
  </React.StrictMode>,
)

